import {BrowserModule} from '@angular/platform-browser';
import {Injector, NgModule} from '@angular/core';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule} from '@angular/material/core';
import { ODataModule, ODataServiceFactory} from 'angular-odata';
import {DerivativeService} from './core/derivative/derivative.service';
import {ParentTableService} from './core/table/parent-table.service';
import {SupplierService} from './core/supplier/supplier.service';
import {QualificationService} from './core/qualification/qualification.service';
import {HistoryService} from './core/history/history.service';
import {SupplierScopeService} from './core/supplier/supplier-scope.service';
import {ScopeService} from './core/scope/scope.service';
import {RequestHttpInterceptor} from './core/loading/interceptors/request-http-interceptor';
import {CustomLoadingService} from './core/loading/custom-loading-service';
import {ClipboardModule} from 'ngx-clipboard';
import {DatePipe} from '@angular/common';
import {UploadHistoryService} from './core/history/upload-history.service';
import {MomentDateAdapter} from '@angular/material-moment-adapter';
import {GlobalsHelper} from './core/table/globals/globals';
import {AppRoutingModule} from './app-routing.module';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {NgxPermissionsModule} from 'ngx-permissions';
import {MeasureService} from './core/measure/measure.service';
import {NominationScopeService} from './core/table/nomination-scope.service';
import {LopaAftersalesService} from './core/table/lopa-aftersales.service';
import {LopaService} from './core/table/lopa.service';
import {FmeaBacklogsService} from './core/table/fmea-backlogs.service';
import {RelocationService} from './core/table/relocation.service';
import {FmeaWrongDeliveriesService} from './core/table/fmea-wrong-deliveries.service';
import {SupplierLqsService} from './core/supplier/supplier-lqs.service';
import {BearerInterceptorService} from './core/auth/interceptors/bearer-interceptor.service';
import {TestCaseService} from './core/table/test-case.service';
import {SsoConfigModule} from './core/auth/sso-config.module';
import {SsoAuthGuard} from './core/auth/guards/sso-auth-guard.service';
import {HttpErrorInterceptor} from './core/auth/interceptors/http-error-interceptor.service';
import {ProxyService} from './core/proxy/proxy.service';
import {DashboardCalendarService} from './core/dashboard/dashboard-calendar.service';
import {SQDataConfiguration} from './core/table/configuration/OData-configuration';
import {EnvironmentHelper} from '../environments/environment-helper';
import {SelectiveSsoInterceptorService} from "./core/auth/interceptors/selective-sso-interceptor.service";
import {applyMobileDialogPatch} from './core/dialog/mobile-dialog-patch';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MM/YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MM/YYYY'
  },
};

@NgModule({
  declarations: [
    AppComponent
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatNativeDateModule,
    NgxPermissionsModule.forRoot(),
    ClipboardModule,
    DragDropModule,
    SsoConfigModule,
    ODataModule.forRoot({
      config: {
        serviceRootUrl: EnvironmentHelper.get('api').odataUrl,
      }
    })
  ],
  providers: [
    DatePipe,
    {provide: HTTP_INTERCEPTORS, useClass: BearerInterceptorService, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: RequestHttpInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: SelectiveSsoInterceptorService, multi: true},
    {provide: ParentTableService, useClass: DerivativeService, multi: true},
    {provide: ParentTableService, useClass: SupplierService, multi: true},
    {provide: ParentTableService, useClass: TestCaseService, multi: true},
    {provide: ParentTableService, useClass: ScopeService, multi: true},
    {provide: ParentTableService, useClass: QualificationService, multi: true},
    {provide: ParentTableService, useClass: MeasureService, multi: true},
    {provide: ParentTableService, useClass: NominationScopeService, multi: true},
    {provide: ParentTableService, useClass: LopaService, multi: true},
    {provide: ParentTableService, useClass: LopaAftersalesService, multi: true},
    {provide: ParentTableService, useClass: FmeaWrongDeliveriesService, multi: true},
    {provide: ParentTableService, useClass: FmeaBacklogsService, multi: true},
    {provide: ParentTableService, useClass: RelocationService, multi: true},
    {provide: ParentTableService, useClass: SupplierLqsService, multi: true},
    {provide: ParentTableService, useClass: HistoryService, multi: true},
    {provide: ParentTableService, useClass: UploadHistoryService, multi: true},
    {provide: ParentTableService, useClass: ProxyService, multi: true},
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: ParentTableService, useClass: ProxyService, multi: true},
    {provide: ParentTableService, useClass: DashboardCalendarService, multi: true},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    SQDataConfiguration,
    ODataServiceFactory,
    SsoAuthGuard,
    DerivativeService,
    SupplierService,
    TestCaseService,
    QualificationService,
    HistoryService,
    SupplierScopeService,
    ScopeService,
    CustomLoadingService,
    UploadHistoryService,
    MeasureService,
    provideHttpClient(withInterceptorsFromDi()),
  ]
})
export class AppModule {
  constructor(private readonly _injector: Injector) {
    GlobalsHelper.setInjector(this._injector);
    applyMobileDialogPatch(this._injector);
  }
}
